import { render, staticRenderFns } from "./WeightDisplay.vue?vue&type=template&id=24333139&lang=pug&"
import script from "./WeightDisplay.vue?vue&type=script&lang=ts&"
export * from "./WeightDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./WeightDisplay.vue?vue&type=style&index=0&id=24333139&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports